import { useIsMobile } from '~/context/common/DeviceContext';
import { getVehicleDetails } from '~/selectors';
import useSelector from '~/store/useSelector';
import { CardContainer, CardSVG, CardTitle, List } from './CategoryCard.styles';
import Feature from './Feature';

export default function InstalledPackagesCard() {
  const { installedPackages = [] } = useSelector(getVehicleDetails);
  const isMobile = useIsMobile();

  const svgName = isMobile
    ? 'installed-packages-32px.svg'
    : 'installed-packages-56px.svg';

  return (
    <CardContainer>
      <CardSVG
        alt="Installed Packages"
        src={`${process.env.CVNA_APP_CDN_ASSETS_PATH}/svgs/cvna-category/${svgName}`}
      />
      <div>
        <CardTitle>Installed Packages</CardTitle>
        <List>
          {installedPackages.map(pack => (
            <Feature key={pack.name} name={pack.name} />
          ))}
        </List>
      </div>
    </CardContainer>
  );
}
